import { Pipe, PipeTransform } from '@angular/core';
import { NavSubItem } from '../models/nav-sub-item';
import { ProductsSubNavItem } from '../models/products-sub-nav-item';

@Pipe({
  name: 'isProductsNavSubItem',
  standalone: false
})
export class IsProductsNavSubItemPipe implements PipeTransform {
  transform(value: NavSubItem): boolean {
    return value instanceof ProductsSubNavItem;
  }
}
